import React, { useEffect, useState, useRef } from 'react';
import { logo } from '../component/ImageList';
import { Link, useNavigate } from 'react-router-dom';
import baseURL from '../component/baseURL';
import { ReactNotifications, Store } from 'react-notifications-component';
import showNotification from '../component/Notification';
import 'animate.css';
import { initLoginAnimation } from '../utils/loginAnimation';

export default function ForgotPassword({ transferProps }) {
    const navigate = useNavigate();
    const canvasContainerRef = useRef(null);
    const animationRef = useRef(null);
    const sceneRef = useRef(null);
    const [email, setEmail] = useState('');
    const [isCodePopupOpen, setIsCodePopupOpen] = useState(false);
    const [agentKey, setAgentCode] = useState(['', '', '', '', '', '']);
    const codeInputRefs = useRef([]);

    useEffect(() => {
        const userID = localStorage.getItem('userID');
        const agentKey = localStorage.getItem('agentKey');

        // If both userID and agentKey exist, navigate to home page

    }, [navigate]);

    useEffect(() => {
        document.body.classList.add('forgot-password-page');

        return () => {
            document.body.classList.remove('forgot-password-page');
        };
    }, []);

    useEffect(() => {
        const cleanup = initLoginAnimation(canvasContainerRef, animationRef, sceneRef);
        return cleanup;
    }, []);

    function forgotPasswordAPI(email) {
        // console.log(email)
        // const { navigate } = this.props.navigation;

        if (email != '' || email != ' ') {
            //Alert.alert('OK')
            let formdata = new FormData();
            formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055')
            formdata.append("email", email)
            fetch(baseURL.URL + '/users/forgot_password', {
                method: 'POST',
                body: formdata
            }).then((response) => response.json())
                .then((responseJson) => {
                    console.log(responseJson)
                    if (responseJson.server.result_code === 200) {
                        // Toast.showWithGravity(responseJson.server.message, Toast.SHORT, Toast.BOTTOM)
                        // this.setState({ submit: true })
                    }
                    else {
                        console.log(responseJson.server.result_code)
                        // Toast.showWithGravity(responseJson.server.message, Toast.SHORT, Toast.BOTTOM)
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
        else {
            // Alert.alert(stringsoflanguages.errorPleaseCheck)
        }
    }


    function addAgentCodeApi(agentKey) {

        let formdata = new FormData();
        formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055')
        formdata.append("user_id", localStorage.getItem('userID'))
        formdata.append("agent_key", agentKey)
        fetch(baseURL.URL + '/users/agent_details', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                console.log('ADD AGENT CODE API RESPONSE-------------------------');
                console.log(responseJson);
                if (responseJson.server.result_code === 200) {
                    //   this._storeAgentKey(aID)
                    //   this.setState({ modalView: false ,result:responseJson.server.response})
                    localStorage.setItem('agentKey', agentKey);
                    localStorage.setItem('firstName', responseJson.server.response.fname);
                    localStorage.setItem('lastName', responseJson.server.response.lname);
                    navigate('/home');
                    showNotification('Success', 'Agent code added successfully', 'success');
                }
                else if (responseJson.server.result_code === 500) {
                    //   this.startShake()
                    // Show error notification
                    showNotification('Error', responseJson.server.message, 'danger');
                }
                else {
                    //   this.startShake()
                    console.log(responseJson.server.result_code)
                    showNotification('Error', 'Something went wrong', 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Something went wrong', 'danger');
            });
    }

    const openCodePopup = () => {
        setIsCodePopupOpen(true);
        // Focus first input when popup opens
        setTimeout(() => {
            if (codeInputRefs.current[0]) {
                codeInputRefs.current[0].focus();
            }
        }, 100);
    };

    const closeCodePopup = () => {
        setIsCodePopupOpen(false);
        setAgentCode(['', '', '', '', '', '']);
    };

    const handleCodeChange = (index, value) => {
        // Only allow single digit
        if (value.length > 1) return;

        // Only allow numbers
        if (value && !/^\d$/.test(value)) return;

        const newCode = [...agentKey];
        newCode[index] = value;
        setAgentCode(newCode);

        // Auto-focus next input if value entered
        if (value && index < 5) {
            codeInputRefs.current[index + 1]?.focus();
        }
    };

    const handleCodeKeyDown = (index, e) => {
        // Handle backspace
        if (e.key === 'Backspace' && !agentKey[index] && index > 0) {
            codeInputRefs.current[index - 1]?.focus();
        }
    };

    const handleCodePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text').trim();
        if (/^\d{6}$/.test(pastedData)) {
            const newCode = pastedData.split('').slice(0, 6);
            setAgentCode(newCode);
            // Focus last input
            codeInputRefs.current[5]?.focus();
        }
    };

    const handleSubmitCode = () => {
        const codeString = agentKey.join('');
        if (codeString.length === 6) {
            console.log('Submitted code:', codeString);
            addAgentCodeApi(codeString);
            closeCodePopup();
        }
    };

    const handleCancelCode = () => {
        closeCodePopup();
    };



    return (
        <>
            <ReactNotifications />
            <section className="login-section">
                <div id="canvas_container" ref={canvasContainerRef}></div>
                <div className='login-holder liquidGlass-wrapper dock' style={{ position: 'relative' }}>

                    <div class="liquidGlass-effect"></div>
                    {/* <div class="liquidGlass-tint"></div> */}
                    <div class="liquidGlass-shine"></div>

                    <figure className='logo-holder mb-4 relative z-10'>
                        <img src={logo} alt="logo" />
                    </figure>
                    <div className='login-form text-center relative z-10'>
                        <h2 className='form-title text-black'>Forgot Password?</h2>
                        <p className='form-description text-black mb-4'>Please enter your email to reset your password.</p>
                        <div>
                            <div className='form-group mb-3'>

                                <input className='form-control ' type='email' id='email' name='email' placeholder='Enter your email' value={email} onChange={(e) => setEmail(e.target.value)} />
                            </div>

                            {/* <button type='submit' className='btn save-btn w-100' onClick={() => forgotPasswordAPI(email)} disabled={!email || email.trim() === ''}>Submit</button> */}
                            <button type='button' className='btn save-btn w-100' onClick={() => forgotPasswordAPI(email)} >Submit</button>
                            <p className='text-black text-sm mt-4'>After submitting you will get a verification code via email,Please check your email address.</p>
                        </div>
                        <button
                            type='button'
                            className='back-btn ml-auto mr-auto mt-4'
                            onClick={() => navigate('/')}

                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M19 12H5M12 19l-7-7 7-7" />
                            </svg>

                        </button>
                    </div>
                </div>

            </section>

            {/* Six Digit Code Popup */}

            {isCodePopupOpen && (
                <>
                    <div className="sidebar-overlay" onClick={handleCancelCode}></div>
                    <div className={`code-popup-modal ${isCodePopupOpen ? 'is-open' : 'is-open'}`}>
                        <div className="code-popup-modal-overlay" onClick={handleCancelCode}></div>
                        <div className="code-popup-modal-content">
                            <div className="code-popup-modal-header">
                                <h3 className="code-popup-modal-title">Enter Verification Code</h3>
                            </div>
                            <div className="code-popup-modal-body">
                                <p className="code-popup-description">Please enter the 6-digit code sent to your email</p>
                                <div className="code-input-container">
                                    {agentKey.map((digit, index) => (
                                        <input
                                            key={index}
                                            ref={(el) => (codeInputRefs.current[index] = el)}
                                            type="text"
                                            inputMode="numeric"
                                            maxLength="1"
                                            className="code-input"
                                            value={digit}
                                            onChange={(e) => handleCodeChange(index, e.target.value)}
                                            onKeyDown={(e) => handleCodeKeyDown(index, e)}
                                            onPaste={handleCodePaste}
                                            autoComplete="off"
                                        />
                                    ))}
                                </div>
                            </div>
                            <div className="code-popup-modal-actions">
                                <button className="btn btn-secondary" onClick={handleCancelCode}>
                                    Cancel
                                </button>
                                <button
                                    className="btn save-btn"
                                    onClick={handleSubmitCode}
                                    disabled={agentKey.join('').length !== 6}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}

        </>
    );
}